import React, { useState, useEffect } from 'react';
import { CrudPurchaseOrders } from '../../Components/Cruds/CrudPurchaseOrders';
import { getUserPermissionsByUserEmail } from '../../api/usersModule/getters';
import { NotFoundPage } from '../NotFoundPage/NotFoundPage';
import { LoadingPage } from '../LoadingPage/LoadingPage';

const moduleName = 'Ordenes de compras';
export const PurchasesPage = ({ signOut, user }) => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [allReceptions, setAllReceptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [change, setChange] = useState(1);
  const [dataLocation, setDataLocation] = useState([]);

  const getPermissions = async () => {
    setLoading(true);

    let permissions = {
      Consultar: false,
      Crear: false,
      Editar: false,
      Eliminar: false,
    };

    try {
      permissions = await getUserPermissionsByUserEmail(
        user.attributes.email,
        user.attributes['custom:project'],
        moduleName
      );
      try {
        permissions['Consultar']
          ? setUserPermissions(permissions)
          : setUserPermissions([]);
      } catch (error) {
        permissions['Consultar'] = false;
      }
      setUserPermissions(permissions);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {userPermissions && userPermissions['Consultar'] ? (
        <div
          style={{
            flex: '1 1 auto',
            display: 'flex',
            flexFlow: 'column',
            height: '100vh',
            overflowY: 'auto',
          }}
        >
				<div
					style={{
						padding: '20px 5%',
						height: '100%',
					}}
				>
					<CrudPurchaseOrders
						userName={user.attributes.family_name}
						permissions={userPermissions}
						project={user.attributes['custom:project']}
					/>
				</div>
			</div>
		) : loading ? (
			<LoadingPage signOut={signOut} user={user} />
		) : (
			<NotFoundPage
				userName={user.attributes.family_name}
				signOut={signOut}
			/>
		)}
	</>
	);
};